import React, { useContext } from "react";
import Moment from "react-moment";
import { Report } from ".";
import { SanityNode } from "../../config/build/models/node";
import { HydrationContext } from "../../context/HydrationContext";
import useTranslations from "../../hooks/useTranslations";
import { isNullOrWhiteSpace } from "../../shared/string";
import LinkWithArrow from "../LinkWithArrow";

interface Props {
  report?: Report;
  archiveLinkReference?: SanityNode;
}

const LatestReportCard = ({ report, archiveLinkReference }: Props) => {
  const translations = useTranslations();

  const hydrated = useContext(HydrationContext);

  if (report) {
    return (
      <div className="flex flex-col p-6 bg-brand-primary-30 border border-brand-primary-20 shadow-lg rounded">
        {!isNullOrWhiteSpace(report.title) && (
          <h2 className="text-brand-senary-100">{report.title}</h2>
        )}
        <h4 className="text-brand-primary-90 uppercase text-base mt-2 font-bold">
          {translations.published ?? "Published"}{" "}
          {hydrated ? <Moment format="ll">{report.publishDate}</Moment> : <>&nbsp;</>}
        </h4>
        <hr className="border-brand-primary-60 mt-8 mb-6" />
        <ul className="flex flex-col items-start text-brand-secondary-70 text-xl font-bold">
          <li>
            <LinkWithArrow
              colorClasses="text-brand-secondary-70 border-brand-secondary-70"
              linkInfo={{
                reference: report,
                title: "Report"
              }}
            />
          </li>
          <li className="mt-3">
            <LinkWithArrow
              colorClasses="text-brand-secondary-70 border-brand-secondary-70"
              // TODO: Correct link to document
              linkInfo={{
                reference: report,
                title: "Presentation document"
              }}
            />
          </li>
          <li className="mt-3">
            <LinkWithArrow
              colorClasses="text-brand-secondary-70 border-brand-secondary-70"
              // TODO: Correct link to video
              linkInfo={{
                reference: report,
                title: "Video presentation"
              }}
            />
          </li>
        </ul>
        <hr className="border-brand-primary-60 mt-8 mb-6" />
        <div className="flex flex-1 justify-end items-end mt-8">
          <LinkWithArrow
            colorClasses="text-brand-senary-100 border-brand-senary-100"
            linkInfo={{
              reference: archiveLinkReference,
              title: translations.allReports ?? ""
            }}
          />
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default LatestReportCard;
